<template>
  <application-layout>
    <v-main>
      <v-container>
        <h1>ACE Dashboard</h1>
        <v-row class="mx-0" align="end">
          <h2>Email Activity</h2>
          <v-spacer />
          <v-col cols="2">
            <v-menu
              data-testid="ace-index-start-date-menu"
              class="ace-index-start-date-menu"
              v-model="startDatePicker"
              max-width="290"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  data-testid="ace-index-start-date-input"
                  class="ace-index-start-date-input"
                  :value="formattedStartDate"
                  label="Start Date"
                  readonly
                  v-on="on"
                  filled
                  hide-details
                />
              </template>
              <v-date-picker
                data-testid="ace-index-start-date-date-picker"
                class="ace-index-start-date-date-picker"
                v-model="startDate"
                @change="handleGetEmails"
              />
            </v-menu>
          </v-col>
          <v-col cols="2">
            <v-menu
              data-testid="ace-index-end-date-menu"
              class="ace-index-end-date-menu"
              v-model="endDatePicker"
              max-width="290"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  data-testid="ace-index-end-date-input"
                  class="ace-index-end-date-input"
                  :value="formattedEndDate"
                  label="End Date"
                  readonly
                  v-on="on"
                  filled
                  hide-details
                />
              </template>
              <v-date-picker
                data-testid="ace-index-end-date-date-picker"
                class="ace-index-end-date-date-picker"
                :max="currentDate"
                v-model="endDate"
                @change="handleGetEmails"
              />
            </v-menu>
          </v-col>
        </v-row>
        <div class="mt-5">
          <v-skeleton-loader
            v-if="loading"
            type="table-heading, list-item-two-line, image, table-tfoot"
          />
          <AMBarChart
            v-else-if="emails.length"
            :items="emails"
            class="mt-5"
          />
        </div>
        <div class="mt-10">
          <v-skeleton-loader
            v-if="loading"
            type="table"
          />
          <v-data-table
            v-else
            class="mt-10"
            :footer-props="{
              ...footerProps,
              itemsPerPageOptions: [25, 50, 100],
            }"
            :headers="headers"
            :items="emails"
            no-data-text="No emails found."
          />
        </div>
      </v-container>
    </v-main>
  </application-layout>
</template>

<script>
import AMBarChart from "@/components/AMBarChart";
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import { aceEmailHeaders } from "@/helpers/ace/ace-index-data-table-headers";
import { footerProps } from "@/helpers/footer-props";
import { formatDate } from "@/helpers/functions/format-date";
import moment from "moment";

export default {
  data() {
    return {
      currentDate: moment.utc().format("YYYY-MM-DD"),
      endDate: moment.utc().format("YYYY-MM-DD"),
      endDatePicker: false,
      headers: aceEmailHeaders,
      footerProps: footerProps,
      loading: false,
      pagination: {
        rowsPerPageOptions: [25, 50, 100],
        totalItems: 100
      },
      startDate: moment.utc().subtract(90, "days").format("YYYY-MM-DD"),
      startDatePicker: false
    };
  },

  methods: {
    formatDate: formatDate,
    handleGetEmails() {
      this.loading = true;
      const payload = {
        start_date: this.startDate,
        end_date: this.endDate
      };
      this.$store.dispatch("ace/getEmails", payload)
        .finally(() => {
          this.loading = false;
        });
    }
  },

  computed: {
    emails() {
      return this.$store.state.ace.emails;
    },
    formattedEndDate() {
      return formatDate(this.endDate);
    },
    formattedStartDate() {
      return formatDate(this.startDate);
    }
  },

  mounted() {
    this.handleGetEmails();
  },

  components: {
    AMBarChart,
    ApplicationLayout
  }
};
</script>
